var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loader",class:( _obj = { 'loader--animated': _vm.animated }, _obj[("loader--" + _vm.variant)] = true, _obj ),style:({ '--color': _vm.rgbColor })},[(_vm.variant === 'dots-2')?[_c('span'),_c('span'),_c('span')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }